import React from "react";

function Mainhero({ value }) {
  return (
    <div>
      <div className="hero">
        <div className="container">
          <div className="row justify-content-between" data-aos="fade-right">
            <div className="col-lg-5">
              <div className="intro-excerpt">{value}</div>
            </div>
            <div className="col-lg-7"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mainhero;
